import React, {useEffect, useState} from 'react';
import FormSelect from "../../../forms/form-control/FormSelect";
import apiClient from "../../../../utils/apiClient";
import {useForm} from "react-hook-form";
import FormSubmitButton from "../../../forms/form-control/FormSubmitButton";
import {updateStateValue} from "../../../../utils/stateHelpers";
import {isEmpty} from "lodash";

/**
 * Filter component for Operational Dashboard + report
 * @param prop
 * @returns {JSX.Element}
 * @constructor
 */
const OperationalDashboardFilters = (prop) => {
    const {register, handleSubmit, errors} = useForm();
    const [disciplines, setDisciplines] = useState([]);
    const {
        setReportFilters,
        setDashboardData,
    } = prop;

    const onSubmit = (data) => {
        updateStateValue(setReportFilters, 'isLoading', true);
        updateStateValue(setReportFilters, 'isSubmitted', true);

        apiClient
            .post('getOperationalDashboardPlusData', {
                discipline_id: data.discipline_id !== '' ? data.discipline_id : null,
            })
            .then(response => {
                if (isEmpty(response.data)) {
                    setDashboardData(null);
                    return;
                }
                setDashboardData(response.data);
            })
            .catch(function () {
                //In case of error do nothing!!
                //let apiClient to handle the error
            }).then(function () {
            updateStateValue(setReportFilters, 'isLoading', false);
        });
    }

    useEffect(() => {
        apiClient
        .get('getDisciplines')
        .then(response => {
            setDisciplines(response.data.disciplines);
        });
    }, []);

    return (
        <form
            className="needs-validation container-fluid"
            onSubmit={handleSubmit(onSubmit)}
        >
            <div className="form-row row s-gy">
                <FormSelect
                    label="Discipline"
                    id="discipline_id"
                    name="discipline_id"
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    options={disciplines}
                    register={register}
                    errors={errors}
                />
                <FormSubmitButton
                    className="col-xs-12 col-sm-6 col-md-3 col-lg-2"
                    label="Show"
                />
            </div>
        </form>
    );
}

export default OperationalDashboardFilters;
